/**
 * Returns a potentially anonymized answer slug of the new mattress reason question.
 */
export function getNewMattressReason(answer: string): string {
  switch (answer) {
    case "physical-complaints":
      return "misc-1";
    case "other":
      return "misc-2";
    default:
      return answer;
  }
}
